<template>
    <div class="settings__reset-pin">
        <div class="settings__reset-pin-item">
            <label class="settings__reset-pin-item-label">{{ getTranslatedText('Enter Current PIN') }}</label>
            <div class="settings__reset-pin-item-value">
                <input v-model="teller_pin" type="password" class="settings__reset-pin-item-input" pattern="[0-9]*" inputmode="numeric" @input="CheckValue($event, 'teller_pin')"/>
            </div>
        </div>
        <div class="settings__reset-pin-item">
            <label class="settings__reset-pin-item-label">{{ getTranslatedText('New PIN') }}</label>
            <div class="settings__reset-pin-item-value">
                <input v-model="teller_pin_new" type="password" class="settings__reset-pin-item-input" pattern="[0-9]*" inputmode="numeric" @input="CheckValue($event, 'teller_pin_new')"/>
            </div>
        </div>
        <div class="settings__reset-pin-item">
            <label class="settings__reset-pin-item-label">{{ getTranslatedText('Confirm New PIN') }}</label>
            <div class="settings__reset-pin-item-value">
                <input v-model="teller_pin_confirmation" type="password" class="settings__reset-pin-item-input" pattern="[0-9]*" inputmode="numeric" @input="CheckValue($event, 'teller_pin_confirmation')"/>
            </div>
        </div>
        <div class="settings__reset-pin-item">
            <div class="settings__reset-pin-item-label"></div>
            <div class="settings__reset-pin-item-value box-button">
                <ButtonCommon text="update" :isLoading="isLoadingButton" @action-button="onCheckValidate" />
                <ButtonCommon type="primary" text="cancel" :isLoading="isLoadingButton" @action-button="$router.go(-1)" />
            </div>
        </div>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'
import ButtonCommon from '@/components/common/button'
import authService from '@/services/auth.service'
import EventBus from '@/utils/EventBus'
import { isArrayEmpty, isStrEmpty } from '@/utils/utils'

export default {
    mixins: [languageMixins],
    components: { ButtonCommon },
    data() {
        return {
            teller_pin: '',
            teller_pin_new: '',
            teller_pin_confirmation: '',
            isLoadingButton: false,
            maxLength: 4
        }
    },
    created() {
        EventBus.$on('on-close-modal-reset-pin', () => this.onCloseModalResetPin())
    },
    destroyed() {
        EventBus.$off('on-close-modal-reset-pin')
    },
    methods: {
        CheckValue(event, property){
            let numericValue = event.target.value.replace(/\D/g, "");
            if(numericValue.length > this.maxLength){
                numericValue = numericValue.slice(0, this.maxLength);
            }
            this[property] = numericValue;
        },
        onCheckValidate() {
            let message = ''
            if (isStrEmpty(this.teller_pin)) {
                message = 'PIN is required'
            } else if (!isStrEmpty(this.teller_pin) && this.teller_pin.length !== 4) {
                message = 'PIN must be 4 numeric characters'
            } else if (isStrEmpty(this.teller_pin_new)) {
                message = 'New PIN is required'
            } else if (!isStrEmpty(this.teller_pin_new) && this.teller_pin_new.length !== 4) {
                message = 'New PIN must be 4 numeric characters'
            } else if (isStrEmpty(this.teller_pin_confirmation)) {
                message = 'Confirm New PIN is required'
            } else if (!isStrEmpty(this.teller_pin_confirmation) && this.teller_pin_confirmation.length !== 4) {
                message = 'Confirm New PIN must be 4 numeric characters'
            }

            if (isStrEmpty(message)) {
                this.onUpdate()
            } else {
                const param = {
                    title: message,
                    status: 'error',
                    description: 'Please Try Again',
                }
                EventBus.$emit('on-show-notications', param)
            }
        },

        async onUpdate() {
            try {
                this.isLoadingButton = true
                let param = {
                    teller_pin: this.teller_pin,
                    teller_pin_new: this.teller_pin_new,
                    teller_pin_confirmation: this.teller_pin_confirmation,
                }
                const resp = await authService.resetPin(param)

                if (resp.status === 'success') {
                    const param = {
                        title: 'reset pin',
                        status: 'success',
                        description: resp.message,
                        nameFunctionClose: 'on-close-modal-reset-pin',
                    }
                    EventBus.$emit('on-show-notications', param)
                } else {
                    const param = {
                        title: resp.message,
                        status: 'error',
                        description: 'Please Try Again',
                    }
                    param.title = resp.data?.errors
                        ? resp.data.errors.map(item => item.message).join(', ')
                        : resp.message;
                    EventBus.$emit('on-show-notications', param)
                }
                this.isLoadingButton = false
            } catch (error) {
                let message = ''
                if (!isArrayEmpty(error.data.errors)) {
                    error.data.errors.map((x) => {
                        message += ` ${x.message}`
                    })
                } else {
                    message = error.message
                }

                const param = {
                    title: message,
                    status: 'error',
                    description: 'Please Try Again',
                }
                param.title = error.data?.errors
                    ? error.data.errors.map(item => item.message).join(', ')
                    : error.message;

                EventBus.$emit('on-show-notications', param)
                this.isLoadingButton = false

                console.log(error)
            }
        },

        async onCloseModalResetPin() {
            try {
                authService.logout()
                this.$router.push('/login')
            } catch (error) {
                console.log(error)
            }
        },
    },
}
</script>
<style lang="scss">
@import '~ThemePath/scss/settings/_reset-pin.scss';
</style>
